import { DataService } from './dataService'

const HsCodeAdditionalService = {
	getHscodeadditionalfees: async(data) => {
		return DataService.get('/admin/hscode_additional_charges', data)
	},
	addHscodeadditionalfees: async (data) => {
		return DataService.post('/admin/hscode_additional_charges', data)
	},
	updateHscodeadditionalfees: async (data) => {
        return DataService.put('/admin/hscode_additional_charges', data)
    },
}

export default HsCodeAdditionalService